<template>
  <div>
    <component :is="component" :slug="slug" />
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useCategoryStore } from '@/stores/category';
import { definePageMeta, useNuxtApp } from '#imports';
import { computed } from 'vue';
import { ROOT_PATH, VARIABLE_ROUTE_TYPE } from '@/resources/helpers';

const StoryblokPage = defineAsyncComponent(() => import('@/components/Pages/StoryblokPage.vue'));
const CategoryPage = defineAsyncComponent(() => import('@/components/Pages/CategoryPage.vue'));
const Homepage = defineAsyncComponent(() => import('@/components/Pages/Homepage/index.vue'));

const route = useRoute();

definePageMeta({
  key: (route) => 'variable-route-page-' + route.slug,
  layout: 'default'
});

const categoryStore = useCategoryStore();
const { categories } = storeToRefs(categoryStore);

const slug = computed(() =>
  route.path === ROOT_PATH
    ? 'homepage-v2'
    : Array.isArray(route.params?.slug)
      ? route.params.slug.join(ROOT_PATH)
      : route.params.slug
);
const isCategoryRoute = computed(() => categories.value.find((c) => c.slug === slug.value) !== undefined);

const component = computed(() => {
  return isCategoryRoute.value ? CategoryPage : route.path === ROOT_PATH ? Homepage : StoryblokPage;
});
</script>
